import { ApiTypes, StateRecord } from '@mode/shared/contract-common';
import { OrgTypes } from '@mode/shared/contract-common';
import { ModeResourceHelper } from '@mode/shared/util-halogen';

export interface AccountResource extends StateRecord, ApiTypes.ModeResource {
  username: string;
  name: string;
  email: string;
  token: string;
  avatar: any;
  user: boolean;
  public: boolean;
  email_verified: boolean;
  plan_code: OrgTypes.PlanCode;
  org_seat_limit_reached: boolean;
  python_performance_first_tier: boolean;
  organization_restricted: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AccountResourceHelper {
  import isResource = ModeResourceHelper.isResource;

  export function isEmailVerified(resource: AccountResource): boolean {
    return isResource(resource) && resource.email_verified;
  }

  export function hasRecentlyViewedReports(resource: AccountResource): boolean {
    return isResource(resource) && resource.hasLink('home_reports_web');
  }

  export function hasDefinitions(resource: AccountResource): boolean {
    return isResource(resource) && resource.hasLink('definitions');
  }

  export function hasDiscoverLink(resource: AccountResource): boolean {
    return isResource(resource) && resource.hasLink('home_discover_web');
  }

  export function hasExplorationsLink(resource: AccountResource): boolean {
    return isResource(resource) && resource.hasLink('home_explorations_web');
  }
}
